import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const TenantTeamsRoot = () => {
  useProtected();

  return <Outlet />;
};

export { TeamsPage } from "./Teams";
export { TeamPage } from "./Team";
